import React, { useState, useEffect, Fragment, useContext, useRef } from 'react';
import { LoginContext } from '../../../hooks/context/LoginContext';
import $ from 'jquery';
import jQuery from 'jquery';
import DataTable from 'datatables.net';
import ReactDOM from 'react-dom';
import BaseSelect from "react-select";
import FixRequiredSelect from '../../../helpers/FixRequiredSelect';
import Modal from 'react-bootstrap/Modal';
import FormRow from '../FormRow';
import MiSelect from '../MiSelect';
import DatePicker from 'rsuite/DatePicker';
import axios from 'axios';
import { Spinner } from 'react-bootstrap';
import swal from 'sweetalert';
import { alertService } from '../../../services/alertservice';
import imageCompression from "browser-image-compression";

import Cookies from 'universal-cookie';

import { getIconoTable, dateSqlToLocal, getDecodedCookie, getDatePickerDaysName } from '../../../helpers/helperApp';

import { getApiUrl } from '../../../helpers/helperApp';

require('datatables.net-dt');
require('datatables.net-responsive');
require('datatables.net-buttons');
require('datatables.net-bs4');

require('datatables.net/js/jquery.dataTables');
require('datatables.net-buttons/js/dataTables.buttons');
require('datatables.net-buttons/js/buttons.colVis');
require('datatables.net-buttons/js/buttons.flash');
require('datatables.net-buttons/js/buttons.html5');
require('datatables.net-buttons/js/buttons.print');
require('datatables.net-select');
require('datatables.mark.js/build/templates/datatables.mark');
require('datatables.mark.js/dist/datatables.mark.es6');
require('datatables.net-rowgroup')

$.DataTable = DataTable;

let date = new Date();
let mesHoy = date.getMonth() + 1;
let h = date.getDate();
let hoy = (h < 10 ? h = '0'+h : h = h )+'/'+(mesHoy < 10 ? mesHoy = '0'+mesHoy : mesHoy = mesHoy )+'/'+date.getFullYear();
let collapsedGroups = {};


var botones = [
    {
        extend: 'pageLength',
        text: `<i style='font-size: 20px;' class='fal fa-list-ol'></i>`,
        className: 'btn btn-flat mr-1 btn-outline-secondary',
        // titleAttr: 'Ver número de registros'
    },  
    {
        extend: 'excel',
        filename: hoy,
        text: `<i style='font-size: 20px;' class='fal fa-file-excel'></i>`,
        className: 'btn btn-flat mr-1 btn-outline-secondary',
        title: hoy,
        // titleAttr: 'Exportar a excel',
        exportOptions: {
            columns: ':visible'
        }
    }, 
    {
        extend: 'pdf',
        filename: hoy,
        text: `<i style='font-size: 20px;' class='fal fa-file-pdf'></i>`,
        className: 'btn btn-flat mr-1 btn-outline-secondary',
        orientation: 'landscape', 
        title: hoy,
        // titleAttr: 'Exportar a pdf',
        exportOptions: {
            columns: ':visible'
        }
    }, 
];

function MiDataTableGesUplm(props){

    const cookies = new Cookies();
    

    const [showModalEdit, saveShowModalEdit] = useState(false);
    const [des, saveDes] = useState("");
    const [tipo, saveTipo] = useState("");
    const [fecha, saveFecha] = useState("");
    const [fechaCad, saveFechaCad] = useState("");
    const [idAdjEdi, saveIdAdjEdi] = useState();
    const [loading, saveLoading ] = useState(false);

    const { apiKey } = useContext(LoginContext);

    // ***** props *****
    const { id, columnas, adjuntosExistentes, saveAdjuntosExistentes, readonly, optionSelect, estadoForm, columnactions, traduction, adjuntosplegados, reloadTable, renovar, verHistoria, saveShowModalHistoria, renovarUrl } = props;
    let { buttons, ordering, order, searching, paging, select, grouping, pagelength } = props;


    const Select = props => (
        <FixRequiredSelect
            {...props}
            SelectComponent={BaseSelect}
            options={optionSelect || optionSelect}
        />
        );
    
    const customStyles = {
        control: (base, state) => ({
            ...base,
            borderColor:'#ced4da',
            borderColor: state.isFocused ? '#80bdff': '#ced4da',
            outline: 0,
            boxShadow: state.isFocused ? '0 0 0 0.2rem rgb(0 123 255 / 25%)' : 'inherit',
            background: readonly === "readonly" || estadoForm === "readonly" ? "#e9ecef" : "white",
            color: "#495057"
            }),
            option: (provided, state) => ({
            ...provided,
            color: "#212529"
            }),
            singleValue: (provided) => ({
            ...provided,
            color: "#495057"
            }),
            menuPortal: (provided) => ({
            ...provided,            
            zIndex: 9999
            })  
    }


    const existenBotones = (botones) => {    
        let data = false;
        botones.map(boton => {                        
            if(boton != undefined){
                if(boton.className.includes('filterBtnGesDoc')){
                    data = true;
                }
            }
        })
        return data;
    }
    if(!existenBotones(botones)){
        const newBtn = {
            extend: 'collection',
            text: "<i style='font-size: 20px' class='fal fa-cabinet-filing '></i>",
            className: `btn btn-flat mr-1 btn-outline-secondary filterBtnGesDoc`,
            action: function ( e, dt, node, config ) {                                    
                        reloadTable( true );
            }                        
        };        
        botones.push(newBtn);
    }

    useEffect(()=>{

        buttons === undefined || buttons === true || buttons === "true" ? buttons = 'Bfrtip' : buttons = 'frtip';
        ordering === undefined ? ordering = true : ordering = ordering;
        order === undefined ? order = [[0,"asc"]] : order = order;
        searching === undefined ? searching = true : searching = searching;
        paging === undefined ? paging = true : paging = paging;
        select === undefined ? select = false : select = select;
        grouping === undefined ? grouping = false : grouping = grouping;
        pagelength === undefined ? pagelength = traduction.datatable.defaultpagelength : pagelength = pagelength;                 

        columnas.map((columna, i) => {
            if( i == 1){
                // Descripcion
                columna.createdCell = (td, cellData, rowData, row, col) => {                     
                    let template = ReactDOM.render(
                        <Fragment>
                            <p className={ rowData.idest == "1" ? "text-black-50 mb-0" : "mb-0" }>{rowData.des}</p>
                            <small className={ rowData.idest == "1" ? "text-black-50 font-italic" : "font-italic" }>{rowData.tipo}</small>
                        </Fragment>
                    ,td);
                    $(td).html(template)                                   
                }
            }
            if( i == 2){
                // F.Alta
                columna.createdCell = (td, cellData, rowData, row, col) => {                     
                    let template = ReactDOM.render(
                        <Fragment>
                            <p className={ rowData.idest == "1" ? "text-black-50 mb-0" : "mb-0" }>{rowData.fa}</p>                            
                        </Fragment>
                    ,td);
                    $(td).html(template)                                   
                }
            }
            if( i == 3){
                // F.Cad
                columna.createdCell = (td, cellData, rowData, row, col) => {                     
                    let template = ReactDOM.render(
                        <Fragment>
                            <p className={ rowData.idest == "1" ? "text-black-50 mb-0" : "mb-0" }>{rowData.fcad}</p>                            
                        </Fragment>
                    ,td);
                    $(td).html(template)                                   
                }
            }
            if( i == 4 ){
                // Estado
                columna.createdCell = (td, cellData, rowData, row, col) => {                     
                    if(rowData.idest == "1"){
                        let templateFec =  ReactDOM.render(                        
                            <span className='text-danger'>{traduction.gesuplm.archivado.title}</span>
                        ,td);
                        $(td).addClass('text-center');
                        $(td).html(templateFec);
                    }else{
                        let texto = "";
                        let colorTxt = "";
                        const fechaActual = new Date();
                        const año = fechaActual.getFullYear();
                        const mes = String(fechaActual.getMonth() + 1).padStart(2, '0');
                        const día = String(fechaActual.getDate()).padStart(2, '0');
                        const fechaFormateada = `${año}-${mes}-${día}`;                                
                        const estado = getEstado(fechaFormateada, rowData.fcad);                    
                        
                        if(estado != null){
                            colorTxt = "text-success";
                            texto = `${estado}d`;
                            if(estado <= 0 || (estado >= 0 && estado <= 15)){
                                colorTxt = "text-danger";                            
                            }
                            if(estado > 15 && estado <= 30){
                                colorTxt = "text-warning";
                            }
                        }
    
                        let templateFec =  ReactDOM.render(                        
                            <span className={colorTxt}>{texto}</span>
                        ,td);
                        $(td).addClass('text-center');                        
                        $(td).html(templateFec);
                    }
                }
            }
            if( i == 5){
                // Acciones
                columna.createdCell = (td, cellData, rowData, row, col) => {                                          
                    if( rowData.permiso == "false" ){
                        // Ocultamos los row de los ficheros de los que no tenemos permiso para ver
                        $(td).parent().css("display", "none")
                    }else{                        
                        let templateBtn =  ReactDOM.render(
                            <div className="flex-center">
                                {
                                    rowData.type == undefined
                                    ?
                                        <a className="btn btn-flat success btnDownload"  href={rowData.rut} target="_blank" >
                                            <i className="fal fa-link " style={{ color: "inherit" }}></i>
                                        </a>  
                                    :
                                        <a className="btn btn-flat success btnDownload"  href={getApiUrl(window.location.origin)+rowData.rut} target="_blank" download={getApiUrl(window.location.origin)+rowData.rut} >
                                            <i className="fal fa-download " data-id={rowData.id} data-rut={getApiUrl(window.location.origin)+rowData.rut} style={{ color: "inherit" }}></i>
                                        </a>   
                                }
                                {
                                    estadoForm !== "disabled" && estadoForm !== "readonly" && readonly != "readonly" && readonly != "true" 
                                    ?
                                        <button 
                                            id={ rowData.id } 
                                            className={rowData.idest == "1" ? "btn btn-flat btn-outline-secondary " : "btn btn-flat btn-outline-primary " } 
                                            style={{border: 0}} 
                                            disabled={ rowData.idest == "1" ? true : false }
                                            onClick={ rowData.idest == "1" ? null : e => { handleEditAdjunto(e, rowData) } }
                                        >
                                                <i  
                                                    className="fal fa-edit "
                                                    id={ rowData.id } 
                                                    onClick={ rowData.idest == "1" ? null : e => { handleEditAdjunto(e, rowData) }}
                                                >
                                                </i>
                                        </button>
                                    :
                                    null
                                }
                                {
                                    rowData.type == undefined 
                                    ?
                                        <button 
                                            id={ rowData.id } 
                                            className={rowData.idest == "1" ? "btn btn-flat btn-outline-secondary " : "btn btn-flat btn-outline-success "  }
                                            style={{border: 0}}
                                            disabled={ rowData.idest == "1" ? true : false } 
                                            onClick={ rowData.idest == "1" ? null : e => { renovarUrl(e, rowData, id) } }
                                        >
                                                <i  
                                                        className="fal fa-sync-alt "
                                                        id={ rowData.id } 
                                                        // onClick={ e => { verHistoria(e, rowData, id) }}
                                                    >
                                                </i>
                                        </button>
                                    :
                                    rowData.idest == "1" && rowData.type != undefined 
                                    ?                                        
                                        <BotonRenovarDisabled key={rowData.id} rowData={rowData} renovar={renovar} />
                                    :
                                        <BotonRenovar key={rowData.id} rowData={rowData} renovar={renovar} />
                                }
                                <button 
                                    id={ rowData.id } 
                                    className={rowData.idest == "1" ? "btn btn-flat btn-outline-secondary " : "btn btn-flat btn-outline-info "  }
                                    style={{border: 0}}
                                    disabled={ rowData.idest == "1" ? true : false } 
                                    onClick={ rowData.idest == "1" ? null : e => { verHistoria(e, rowData, id) } }
                                >
                                        <i  
                                                className="fal fa-history "
                                                id={ rowData.id } 
                                                // onClick={ e => { verHistoria(e, rowData, id) }}
                                            >
                                        </i>
                                </button>
                                {
                                    estadoForm !== "disabled" && estadoForm !== "readonly" && readonly != "readonly" && readonly != "true" 
                                    ?
                                        <span 
                                            id={ rowData.id } 
                                            className={ rowData.idest == "1" ? "btn btn-flat btn-outline-success " : "btn btn-flat btn-outline-danger " }
                                            style={{border: 0}} 
                                            onClick={ rowData.idest == "1" ? e => {archivar(e, rowData, false)} : e => {archivar(e, rowData)} }
                                        >
                                                <i  
                                                        className="fal fa-cabinet-filing "
                                                        id={ rowData.id } 
                                                        onClick={ rowData.idest == "1" ? e => {archivar(e, rowData, false)} : e => {archivar(e, rowData)} }
                                                    >
                                                </i>
                                        </span>
                                    :
                                    null
                                }
                            </div>
                        ,td);
                        $(td).html(templateBtn)
                    }                                        
                }
            }                
        })        

        if( adjuntosExistentes ){
            if( adjuntosExistentes.length > 0 ){
                if ( $.fn.DataTable.isDataTable("."+id) ) {
                    let oTable = $("."+id).DataTable();
                    oTable.clear( );
                    for (let i = 0; i < adjuntosExistentes.length; i++){
                        oTable.row.add(adjuntosExistentes[i]);      
                    }
                    oTable.draw();               
                }else{
                    $("."+id).DataTable({                      
                        mark: true,
                        columnDefs: [], 
                        rowId: function(a) {
                            return '#row-' + a.id;},
                        dom: buttons,
                        data: adjuntosExistentes,
                        columns: columnas,
                        ordering: ordering,
                        order: order,
                        searching: searching,
                        paging: paging,
                        select: select,
                        buttons: [botones],
                        // fixedHeader: true,
                        // scrollX: true,
                        responsive: false, 
                        autoWidth: false,
                        retrieve: true,
                        pageLength: parseInt(pagelength),
                        lengthMenu: [
                            [ 10, 25, 50, 100 ],
                            [ '10', '25', '50', '100' ]
                        ],
                        deferRender: true,
                        language: {
                            "sProcessing":    traduction.datatable.sprocessing.title,
                            "sLengthMenu":    traduction.datatable.slengthmenu.title,
                            "sZeroRecords":   traduction.datatable.szerorecords.title,
                            "sEmptyTable":    traduction.datatable.semptytable.title,
                            "sInfo":          traduction.datatable.sinfo.title,
                            "sInfoEmpty":     traduction.datatable.sinfoempty.title,
                            "sInfoFiltered":  traduction.datatable.sinfofiltered.title,
                            "sInfoPostFix":   traduction.datatable.sinfopostfix.title,
                            "sSearch":        traduction.datatable.ssearch.title,
                            "sUrl":           traduction.datatable.surl.title,
                            "sInfoThousands":  traduction.datatable.sinfothousands.title,
                            "sLoadingRecords": traduction.datatable.sloadingrecords.title,
                            "oPaginate": {
                                "sFirst":    traduction.datatable.sfirst.title,
                                "sLast":    traduction.datatable.slast.title,
                                "sNext":    traduction.datatable.snext.title,
                                "sPrevious": traduction.datatable.sprevious.title
                            },
                            "oAria": {
                                "sSortAscending":  traduction.datatable.ssortascending.title,
                                "sSortDescending": traduction.datatable.ssortdescending.title
                            },
                            select: {
                                rows: traduction.datatable.rows.title
                            },
                            buttons: {
                                copyTitle: traduction.datatable.copytitle.title,
                                copyKeys: traduction.datatable.copykeys.title,
                                copySuccess: {
                                    _: traduction.datatable.copysuccess.many.title,
                                    1: traduction.datatable.copysuccess.one.title
                                },
                            }        
                        },
                        rowGroup: {
                            // Uses the 'row group' plugin
                            dataSrc: "groupby",
                            startRender: function (rows, group) { 
                                if( grouping ){
                                    let collapsed = !!collapsedGroups[group];                                 
                                    const idGroup = group;
                                    
                                    if(adjuntosplegados){
                                        Object.keys(collapsedGroups).length == 0 && idGroup != "0" ? collapsed = true: collapsed = !collapsedGroups[group];
                                    }
                        
                                    rows.nodes().each(function (r) {
                                        r.style.display = collapsed ? 'none' : '';
                                    });    
                
                                    let nombreCategoria = "";
                                    if(group == 0){ 
                                        nombreCategoria = traduction.datatable.sintipo.title;                                                                      
                                    }else{
                                        const nombreGrupo = adjuntosExistentes.filter((option) => {                            
                                            if( option.idtip == group ){
                                                return option.tipo;
                                            }                        
                                        });                        
                                        // MODIFICACIÓN PARA ERROR RAMPESCA PAGINA CENTROS SELECCIONAR 1 CENTRO
                                        if( nombreGrupo[0] && nombreGrupo[0].tipo ){
                                            nombreCategoria = nombreGrupo[0].tipo; 
                                        }else{
                                            nombreCategoria = traduction.datatable.sintipo.title;
                                        }
                                    }
                                    // Add category name to the <tr>. NOTE: Hardcoded colspan
                                    return $('<tr/>')
                                        .append('<td colspan="5" style="background-Color: #e5e5e5 !important; cursor: pointer"><h6>' + nombreCategoria + ' (' + rows.count() + ')</h6></td>')
                                        .attr('data-name', group)
                                        .toggleClass('collapsed', collapsed)
                                        .bind('click', (e, group) => expandCollapse(e, idGroup));
                                }
                            }
                        },                                            
                    })
                }  
                // saveLoadingTable(false);       
            }else{
                if ( $.fn.DataTable.isDataTable("."+id) ) {
                    let oTable = $("."+id).DataTable();
                    oTable.clear();
                    oTable.draw();               
                }{               
                    $("."+id).DataTable({                      
                        mark: true,
                        columnDefs: [], 
                        rowId: function(a) {
                            return '#row-' + a.id;},
                        dom: buttons,
                        data: null,
                        columns: columnas,
                        ordering: ordering,
                        order: order,
                        searching: searching,
                        paging: true,
                        select: select,
                        buttons: [botones],
                        // fixedHeader: true,
                        // scrollX: true,
                        responsive: false, 
                        autoWidth: false,
                        retrieve: true,
                        pageLength: parseInt(pagelength),
                        lengthMenu: [
                            [ 10, 25, 50, 100 ],
                            [ '10', '25', '50', '100' ]
                        ],
                        deferRender: true,
                        language: {
                            "sProcessing":    traduction.datatable.sprocessing.title,
                            "sLengthMenu":    traduction.datatable.slengthmenu.title,
                            "sZeroRecords":   traduction.datatable.szerorecords.title,
                            "sEmptyTable":    traduction.datatable.semptytable.title,
                            "sInfo":          traduction.datatable.sinfo.title,
                            "sInfoEmpty":     traduction.datatable.sinfoempty.title,
                            "sInfoFiltered":  traduction.datatable.sinfofiltered.title,
                            "sInfoPostFix":   traduction.datatable.sinfopostfix.title,
                            "sSearch":        traduction.datatable.ssearch.title,
                            "sUrl":           traduction.datatable.surl.title,
                            "sInfoThousands":  traduction.datatable.sinfothousands.title,
                            "sLoadingRecords": traduction.datatable.sloadingrecords.title,
                            "oPaginate": {
                                "sFirst":    traduction.datatable.sfirst.title,
                                "sLast":    traduction.datatable.slast.title,
                                "sNext":    traduction.datatable.snext.title,
                                "sPrevious": traduction.datatable.sprevious.title
                            },
                            "oAria": {
                                "sSortAscending":  traduction.datatable.ssortascending.title,
                                "sSortDescending": traduction.datatable.ssortdescending.title
                            },
                            select: {
                                rows: traduction.datatable.rows.title
                            },
                            buttons: {
                                copyTitle: traduction.datatable.copytitle.title,
                                copyKeys: traduction.datatable.copykeys.title,
                                copySuccess: {
                                    _: traduction.datatable.copysuccess.many.title,
                                    1: traduction.datatable.copysuccess.one.title
                                },
                            }        
                        },
                        rowGroup: {
                            // Uses the 'row group' plugin
                            dataSrc: "groupby",
                            startRender: function (rows, group) { 
                                if( grouping ){
                                    let collapsed = !!collapsedGroups[group];                                 
                                    const idGroup = group;
                                    
                                    if(adjuntosplegados){
                                        Object.keys(collapsedGroups).length == 0 && idGroup != "0" ? collapsed = true: collapsed = !collapsedGroups[group];
                                    }
                        
                                    rows.nodes().each(function (r) {
                                        r.style.display = collapsed ? 'none' : '';
                                    });    
                
                                    let nombreCategoria = "";
                                    if(group == 0){ 
                                        nombreCategoria = traduction.datatable.sintipo.title;                                                                      
                                    }else{
                                        const nombreGrupo = adjuntosExistentes.filter((option) => {                            
                                            if( option.idtip == group ){
                                                return option.tipo;
                                            }                        
                                        });                                                                
                                        if( nombreGrupo[0] && nombreGrupo[0].tipo ){
                                            nombreCategoria = nombreGrupo[0].tipo; 
                                        }else{
                                            nombreCategoria = traduction.datatable.sintipo.title;
                                        }
                                    }
                                    // Add category name to the <tr>. NOTE: Hardcoded colspan
                                    return $('<tr/>')
                                        .append('<td colspan="5" style="background-Color: #e5e5e5 !important; cursor: pointer"><h6>' + nombreCategoria + ' (' + rows.count() + ')</h6></td>')
                                        .attr('data-name', group)
                                        .toggleClass('collapsed', collapsed)
                                        .bind('click', (e, group) => expandCollapse(e, idGroup));
                                }
                            }
                        },                                            
                    })
                }
                // saveLoadingTable(false);
            }
        }else{
            if ( $.fn.DataTable.isDataTable("."+id) ) {
                let oTable = $("."+id).DataTable();
                oTable.clear();
                oTable.draw();               
            }{               
                $("."+id).DataTable({                      
                    mark: true,
                    columnDefs: [], 
                    rowId: function(a) {
                        return '#row-' + a.id;},
                    dom: buttons,
                    data: null,
                    columns: columnas,
                    ordering: ordering,
                    order: order,
                    searching: searching,
                    paging: true,
                    select: select,
                    buttons: [botones],
                    // fixedHeader: true,
                    // scrollX: true,
                    responsive: false, 
                    autoWidth: false,
                    retrieve: true,
                    pageLength: parseInt(pagelength),
                    lengthMenu: [
                        [ 10, 25, 50, 100 ],
                        [ '10', '25', '50', '100' ]
                    ],
                    deferRender: true,
                    language: {
                        "sProcessing":    traduction.datatable.sprocessing.title,
                        "sLengthMenu":    traduction.datatable.slengthmenu.title,
                        "sZeroRecords":   traduction.datatable.szerorecords.title,
                        "sEmptyTable":    traduction.datatable.semptytable.title,
                        "sInfo":          traduction.datatable.sinfo.title,
                        "sInfoEmpty":     traduction.datatable.sinfoempty.title,
                        "sInfoFiltered":  traduction.datatable.sinfofiltered.title,
                        "sInfoPostFix":   traduction.datatable.sinfopostfix.title,
                        "sSearch":        traduction.datatable.ssearch.title,
                        "sUrl":           traduction.datatable.surl.title,
                        "sInfoThousands":  traduction.datatable.sinfothousands.title,
                        "sLoadingRecords": traduction.datatable.sloadingrecords.title,
                        "oPaginate": {
                            "sFirst":    traduction.datatable.sfirst.title,
                            "sLast":    traduction.datatable.slast.title,
                            "sNext":    traduction.datatable.snext.title,
                            "sPrevious": traduction.datatable.sprevious.title
                        },
                        "oAria": {
                            "sSortAscending":  traduction.datatable.ssortascending.title,
                            "sSortDescending": traduction.datatable.ssortdescending.title
                        },
                        select: {
                            rows: traduction.datatable.rows.title
                        },
                        buttons: {
                            copyTitle: traduction.datatable.copytitle.title,
                            copyKeys: traduction.datatable.copykeys.title,
                            copySuccess: {
                                _: traduction.datatable.copysuccess.many.title,
                                1: traduction.datatable.copysuccess.one.title
                            },
                        }        
                    },
                    rowGroup: {
                        // Uses the 'row group' plugin
                        dataSrc: "groupby",
                        startRender: function (rows, group) { 
                            if( grouping ){
                                let collapsed = !!collapsedGroups[group];                                 
                                const idGroup = group;
                                
                                if(adjuntosplegados){
                                    Object.keys(collapsedGroups).length == 0 && idGroup != "0" ? collapsed = true: collapsed = !collapsedGroups[group];
                                }
                    
                                rows.nodes().each(function (r) {
                                    r.style.display = collapsed ? 'none' : '';
                                });    
            
                                let nombreCategoria = "";
                                if(group == 0){ 
                                    nombreCategoria = traduction.datatable.sintipo.title;                                                                      
                                }else{
                                    const nombreGrupo = adjuntosExistentes.filter((option) => {                            
                                        if( option.idtip == group ){
                                            return option.tipo;
                                        }                        
                                    });                        
                                    // MODIFICACIÓN PARA ERROR RAMPESCA PAGINA CENTROS SELECCIONAR 1 CENTRO
                                    if( nombreGrupo[0] && nombreGrupo[0].tipo ){
                                        nombreCategoria = nombreGrupo[0].tipo; 
                                    }else{
                                        nombreCategoria = traduction.datatable.sintipo.title;
                                    }
                                }
                                // Add category name to the <tr>. NOTE: Hardcoded colspan
                                return $('<tr/>')
                                    .append('<td colspan="5" style="background-Color: #e5e5e5 !important; cursor: pointer"><h6>' + nombreCategoria + ' (' + rows.count() + ')</h6></td>')
                                    .attr('data-name', group)
                                    .toggleClass('collapsed', collapsed)
                                    .bind('click', (e, group) => expandCollapse(e, idGroup));
                            }
                        }
                    },                                            
                })
            }
            // saveLoadingTable(false);            
        }



        
               
    }, [adjuntosExistentes, optionSelect])

    const getEstado = (ini, fin) => {
        // Validar que las fechas no sean "0000-00-00"
        if (ini === "0000-00-00" || fin === "0000-00-00") {
            return null;
        }

        // Convertir las fechas a objetos Date
        const fechaIni = new Date(ini);
        const fechaFin = new Date(fin);

        // Calcular la diferencia en milisegundos
        const diferenciaMs = fechaFin - fechaIni;

        // Convertir a días (1 día = 86400000 ms)
        const diferenciaDias = Math.floor(diferenciaMs / (1000 * 60 * 60 * 24));

        return diferenciaDias;
    }
    
    const handleEditAdjunto = (e, rowData) => {
        e.preventDefault();       
        saveDes(rowData.des);
        saveTipo(rowData.idtip);
        saveFecha(rowData.fa);
        saveFechaCad(rowData.fcad);
        saveIdAdjEdi(rowData.id);
        saveShowModalEdit(true)        
    }

    const editAction = async (e) => {
        e.preventDefault();
        saveLoading(true);

        const data = new FormData();
        data.append("validacion", apiKey());
        data.append("idadj", idAdjEdi);
        data.append("des", des);
        data.append("tipo", tipo);
        data.append("fa", fecha);
        data.append("fcad", fechaCad);
        const respuesta = await axios.post(getApiUrl(window.location.origin)+'/gesdoc/editdocumentacion',data);

        if(respuesta.data.error != ""){
            // Mostrar error 
            saveLoading(false);
            saveShowModalEdit(false);
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data.error}`, {autoClose: true});
            return;
        }
        await reloadTable();
        saveLoading(false);        
        saveShowModalEdit(false) 
        
        if(id == 'tablaHistoriaAdjs'){
            saveShowModalHistoria(false);
        }

        alertService.success(`<i class="fal fa-check-circle mr-1"></i>${traduction.gesuplm.modaledi.updateok.title}`, {autoClose: true});
    }

    function BotonRenovar({ rowData, renovar }) {
        const fileInputRef = React.useRef(null);

        const handleFileChange = async (e, rowData) => {
            const file = e.target.files[0];            
            if (file) {
                renovar([file], rowData, id);
            }
        };

        const handleClick = () => {
            if (fileInputRef.current) {
                fileInputRef.current.click();
            }
        };

        return (
            <Fragment>
                <input
                    type="file"
                    id={"inputFilesrenovar"}                         
                    name="inputFilesrenovar"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={e => handleFileChange(e, rowData)}
                    disabled={false}
                />
                <span                        
                    className="btn btn-flat btn-outline-success"
                    style={{
                        border: 'none',                                                
                        // padding: '0.5rem',
                        cursor: 'pointer'
                    }}
                        onClick={handleClick}
                >
                    <i className="fal fa-sync-alt"></i>
                </span>
            </Fragment>
        );
    }

    function BotonRenovarDisabled({ rowData, renovar }) {
        const fileInputRef = React.useRef(null);        

        return (
            <Fragment>                
                <button                        
                    className="btn btn-flat btn-outline-secondary"
                    disabled={true}
                    style={{
                        border: 'none',                                                
                        // padding: '0.5rem',                    
                    }}
                        onClick={null}
                >
                    <i className="fal fa-sync-alt"></i>
                </button>
            </Fragment>
        );
    }

    const archivar = (e, rowData, archivar=true) => {
        e.preventDefault();
        // archivar=true poner a 1 en bbdd
        swal({
            title: archivar == true ? traduction.gesuplm.swalarchivar.title.title : traduction.gesuplm.swalarchivar.titledesarchivar.title,
            text: archivar == true ? traduction.gesuplm.swalarchivar.text.title : traduction.gesuplm.swalarchivar.textdesarchivar.title,
            icon: "warning",
            buttons: {
                cancel : {text: traduction.gesuplm.swalarchivar.btncancel.title, className:'btn btn-flat mr-1 btn-outline-secondary', visible: true},
                confirm : {text: traduction.gesuplm.swalarchivar.btnconfirm.title, className:'btn btn-flat mr-1 btn-outline-danger btnSwalDelete'}
            } 
        }).then(confirmacion => {
            if(confirmacion){
                archivarCall(rowData.id, archivar == true ? 1 : 0);
            }
        })

    }

    const archivarCall = async(idAdj, idEst) => {

        saveLoading(true);

        const data = new FormData();
        data.append("validacion", apiKey());
        data.append("idadj", idAdj);
        data.append("idest", idEst);
        const respuesta = await axios.post(getApiUrl(window.location.origin)+'/gesdoc/archivar',data);

        if(respuesta.data.error != ""){
            // Mostrar error 
            saveLoading(false);            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data.error}`, {autoClose: true});
            return;
        }        
        await reloadTable();
        if(id == 'tablaHistoriaAdjs'){
            saveShowModalHistoria(false);
        }
        saveLoading(false);
        if(idEst == 1){
            alertService.success(`<i class="fal fa-check-circle mr-1"></i>${traduction.gesuplm.archivadook.title}`, {autoClose: true});
        }else{
            alertService.success(`<i class="fal fa-check-circle mr-1"></i>${traduction.gesuplm.desarchivadook.updateok.title}`, {autoClose: true});
        }
    }
    
    const handleInputDes = (e) => {
        const { name, value } = e.target;
        saveDes(value)
    }

    const handleInputFecha = (val, saveData) => {
        let value;
        if(val == null){
            value = '0000-00-00';
        }else{
            const anho = val.getFullYear()
            const mes = val.getMonth()+1 < 10 ? '0'+(val.getMonth()+1) : val.getMonth()+1;
            const dia = val.getDate() < 10 ? '0'+val.getDate() : val.getDate();
            const horas = val.getHours() < 10 ? '0' + val.getHours() : val.getHours(); 
            const minutos = val.getMinutes() < 10 ? '0' + val.getMinutes() : val.getMinutes();
            // value = `${anho}-${mes}-${dia}T${horas}:${minutos}`;
            value = `${anho}-${mes}-${dia}`;
        }
        saveData(value)
    }

    const handleSelectTipo = (selectedItem, nameOfComponent) => {
        if( selectedItem ){
            saveTipo(selectedItem.value)
        }else{
            saveTipo("")
        }
    }

    const expandCollapse = (e, group) => {
        collapsedGroups[group] = !collapsedGroups[group];
        let table = $("."+id).DataTable();
        table.draw(false);
    }
      
    // Busqueda en los input, select de la tabla
    $.fn.dataTableExt.ofnSearch['html-input'] = function(value) {
        if(/^(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)$/.test(value) || /^(\d{4})-(\d\d)-(\d\d)$/.test(value) ){            
            // return dateSqlToLocal(value+"T00:00", getDecodedCookie('idioma'));
            return value;
        }else{            
            const busqueda = optionSelect.filter(option => option.value == value)
            if( busqueda[0] ){
                return busqueda[0].label;
            }else if(value == 0){
                return traduction.datatable.sintipo.title;
            }else{
                return value;
            }            
        }
    };

    // Código para evitar los acentos en las búsquedas
    function removeAccents ( data ) {
        if ( data.normalize ) {
            // Use I18n API if avaiable to split characters and accents, then remove
            // the accents wholesale. Note that we use the original data as well as
            // the new to allow for searching of either form.
            return data +' '+ data
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');
        }
     
        return data;
    }
    var searchType = jQuery.fn.DataTable.ext.type.search;

    searchType.string = function ( data ) {
        return ! data ?
            '' :
            typeof data === 'string' ?
                removeAccents( data ) :
                data;
    };
    
    searchType.html = function ( data ) {
        return ! data ?
            '' :
            typeof data === 'string' ?
                removeAccents( data.replace( /<.*?>/g, '' ) ) :
                data;
    };
    // FIN: Código para evitar los acentos en las búsquedas


    return(
        <Fragment>
            {   loading ? 
                    <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                        <Spinner animation="border" />
                    </div>
                :
                null
            }
            {
                adjuntosExistentes.length > 0
                ?
                    <div className="mb-2" style={{overflowX: "auto"}}>
                        <table id={id} className={id+" table table-sm table-bordered table-striped table-hover dataTable adjPlus"} style={{width:"100%"}}>                            
                        </table>
                        {
                            showModalEdit
                            ?
                                <Modal
                                    size="xl w95 mxInitial"
                                    show={true}
                                    // onHide={ () => saveShowModalEdit(false)}                            
                                    aria-labelledby="example-custom-modal-styling-title"
                                    centered={true}
                                    contentClassName=""
                                    backdropClassName=""                                              
                                    >                                                       
                                    <Modal.Body>
                                    <div className='row'>
                                        <div className='col-12 col-lg-4 mb-3 pl-3'>
                                            <label htmlFor='modaldesc'>{traduction.gesuplm.modaledi.labeldesc.title}</label>
                                            <textarea
                                                id={'modaldesc'} 
                                                placeholder={traduction.uplm.textarea.title} 
                                                className="form-control fileExist" 
                                                rows="1" 
                                                defaultValue={des} 
                                                // name={nombre+id+"**"+rowData.id}  
                                                style={{resize: "none"}} 
                                                onChange= { e => handleInputDes(e) }
                                                >                                        
                                            </textarea>
                                        </div>
                                        <div className='col-12 col-lg-4'>                                            
                                            <MiSelect  
                                                estadoForm=  { "" }
                                                val=         { tipo }   
                                                loading=     { false }
                                                id=          { "edittipo" }    
                                                name=        { null }   
                                                label=       { traduction.gesuplm.modaledi.labeltipo.title }    
                                                placeholder= { "" }
                                                col=         { "12 p-0" } 
                                                isClearable= { false }
                                                isSearchable={ true }
                                                dataType=    { "codigo" }
                                                data=        { optionSelect }
                                                required=    { false } 
                                                disabled=    { false }
                                                readOnly =   { false }
                                                disablethisid={false}
                                                disableids=   {false}
                                                formulario= { {id:0} }   
                                                change= { handleSelectTipo }
                                            />
                                        </div>
                                        <div className='col-12 col-lg-2'> 
                                            <label htmlFor='edifecha'>{traduction.gesuplm.modaledi.labelfec.title}</label>                                           
                                            <DatePicker
                                                id={"edifecha"}
                                                // name={nombre+id+"**"+rowData.id+"**fcad"}
                                                placeholder={' '}
                                                format={"yyyy-MM-dd"}
                                                defaultValue={ fecha == '0000-00-00T00:00' || fecha == '0000-00-00' ||  fecha == '' ? null : new Date(fecha) }
                                                onOk={(value, event) => handleInputFecha(value, saveFecha)}
                                                onChange={ (value, event) => handleInputFecha(value, saveFecha) }                                
                                                readOnly={ false }
                                                className={''}
                                                disabled={ false } 
                                                // showTime
                                                block={true}
                                                weekStart={1}
                                                locale={getDatePickerDaysName()}
                                                placement={'auto'}
                                            /> 
                                        </div>
                                        <div className='col-12 col-lg-2'> 
                                            <label htmlFor='edifechacad'>{traduction.gesuplm.modaledi.labelfeccad.title}</label>                                           
                                            <DatePicker
                                                id={"edifechacad"}
                                                // name={nombre+id+"**"+rowData.id+"**fcad"}
                                                placeholder={' '}
                                                format={"yyyy-MM-dd"}
                                                defaultValue={ fechaCad == '0000-00-00T00:00' || fechaCad == '0000-00-00' ||  fechaCad == '' ? null : new Date(fechaCad) }
                                                onOk={(value, event) => handleInputFecha(value, saveFechaCad)}
                                                onChange={ (value, event) => handleInputFecha(value, saveFechaCad) }                                
                                                readOnly={ false }
                                                className={''}
                                                disabled={ false } 
                                                // showTime
                                                block={true}
                                                weekStart={1}
                                                locale={getDatePickerDaysName()}
                                                placement={'auto'}
                                            /> 
                                        </div>
                                    </div>
                                    {   loading ? 
                                            <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                                <Spinner animation="border" />
                                            </div>
                                        :
                                        null
                                    }
                                    </Modal.Body>                            
                                    <Modal.Footer>
                                        <div className='text-right'>
                                            <button type="button" className="btn btn-success mr-1" onClick={ (e) => editAction(e) }>
                                                {traduction.gesuplm.modaledi.btnaceptar.title}
                                            </button>
                                            <button type="button" className="btn btn-danger" onClick={ () => saveShowModalEdit(false) }>
                                                {traduction.gesuplm.modaledi.btncancelar.title}
                                            </button>
                                        </div>
                                    </Modal.Footer>
                                </Modal>
                            :
                                null
                        }
                    </div>                                   
                :
                    null
            }                           
        </Fragment>
    )
}

export default MiDataTableGesUplm;